export default "__VITE_ASSET__Dkmm7_sm__"